export default __webpack_public_path__ + "bd0b7615c086a7bf089a8e569669ff1e.png";